import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./PlaylistCard.module.scss";
import { useNavigate } from "react-router-dom";

export interface IPlaylistCardProps {
  title: string;
  difficultyIdentifier?: "rookie" | "intermediate" | "advanced";
  subtext: string;
  imgUrl: string;
  isDisplayedInGroup: boolean;
  isDisplayedInGroupContents?: boolean;
  playlistId: number;
}

export function getPlaylistCardUrl(playlistId: number): string {
  return `/playlist/${playlistId}`;
}

export const PlaylistCard: VoidFunctionComponent<IPlaylistCardProps> = ({
  title,
  difficultyIdentifier,
  subtext,
  imgUrl,
  isDisplayedInGroup,
  isDisplayedInGroupContents,
  playlistId
}) => {
  const useClasses: string[] = [s.playlistCard];
  const navigate = useNavigate();
  if (difficultyIdentifier) {
    useClasses.push(s[`${difficultyIdentifier}`]);
  }

  if (isDisplayedInGroup) {
    useClasses.push(s.compact);
  }

  if (isDisplayedInGroupContents) {
    useClasses.push(s.groupView);
  }

  return (
    <button type={"button"} className={useClasses.join(` `)} onClick={() => navigate(getPlaylistCardUrl(playlistId))}>
      <h4 className={s.cardTitle}>{title}</h4>
      <p className={s.cardInfo}>{subtext}</p>
      <div className={s.cardImgWrapper}>
        <img className={s.cardImg} src={imgUrl} alt={""} width={"600"} height={"600"} />
      </div>
    </button>
  );
}
